import _ from 'lodash';
import React, { Component } from 'react';
import {
  StripeProvider,
  Elements
} from 'react-stripe-elements';

import config from 'config/config';
import { loadScript } from 'utils';
import StripeCardWrapped, { StripeCard } from './StripeCard';


export class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stripeLoaded: false,
      stripeLoadedError: false,
      stripePublicKey: config.stripePublicKey || false
    };

    _.bindAll(this, ['loadStripeScript', 'verifyState']);
  }

  componentDidMount() {
    this.loadStripeScript();
  }

  loadStripeScript() {
    loadScript('https://js.stripe.com/v3/')
      .then(() => {
        this.setState({ stripeLoaded: true });
      })
      .catch(() => {
        this.setState({ stripeLoadedError: true, stripeLoaded: true });
      });
  }

  verifyState() {
    if (!this.state.stripePublicKey) {
      return 'Credit card checking is temporarily disabled.';
    }

    if (!this.state.stripeLoaded) {
      return 'Loading...';
    }

    if (this.state.stripeLoadedError) {
      return 'Something went wrong connecting to provider, refresh the page.';
    }

    return false;
  }

  render() {
    let msg = this.verifyState();

    return (
      <div>
        {
          !msg ?
            <StripeProvider apiKey={this.state.stripePublicKey}>
              <Elements locale='en'>
                <StripeCardWrapped
                  dispatch={this.props.dispatch}
                  methodConfirmed={this.props.methodConfirmed}
                />
              </Elements>
            </StripeProvider>
            : <StripeCard msg={msg}/>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/steps/payment/Payment.js